import { render, staticRenderFns } from "./SettingComponentPage.vue?vue&type=template&id=76baea36&scoped=true&"
import script from "./SettingComponentPage.vue?vue&type=script&lang=js&"
export * from "./SettingComponentPage.vue?vue&type=script&lang=js&"
import style0 from "./SettingComponentPage.vue?vue&type=style&index=0&id=76baea36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76baea36",
  null
  
)

export default component.exports